import { render, staticRenderFns } from "./SpecialIndex.vue?vue&type=template&id=3cc3ebab&scoped=true"
import script from "./SpecialIndex.vue?vue&type=script&lang=js"
export * from "./SpecialIndex.vue?vue&type=script&lang=js"
import style0 from "./SpecialIndex.vue?vue&type=style&index=0&id=3cc3ebab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc3ebab",
  null
  
)

export default component.exports